/**
 * Created: 2026-02-20
 * Initial commit: Add system test page with error logging mutation
 *
 * Dev-only page for triggering system test mutations.
 */

import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { Box, Button, Typography } from '@mui/material'
import { TestLogErrorDocument } from '../gql/graphql'

gql`
  mutation TestLogError {
    testLogError {
      ... on GraphqlSuccess {
        success
      }
      ... on GraphqlRequestError {
        code
        message
      }
    }
  }
`

export default function SystemTestPage() {
  const [testLogError, { loading }] = useMutation(TestLogErrorDocument)

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        System Test
      </Typography>
      <Button
        variant="outlined"
        color="warning"
        disabled={loading}
        onClick={() => testLogError()}
      >
        Trigger Error Log
      </Button>
    </Box>
  )
}
